import { getReduxStore } from "./redux-host.js";
function getIsModalVisible(modalId) {
  return ({ modal }) => {
    var _a;
    return ((_a = modal.visibleModal) == null ? void 0 : _a.id) === modalId;
  };
}
function isModalVisible(modalId) {
  var _a;
  const { modal } = getReduxStore().getState();
  return ((_a = modal.visibleModal) == null ? void 0 : _a.id) === modalId;
}
function getHostInfo() {
  const { host } = getReduxStore().getState();
  if (!Object.keys(host.context).length) {
    throw new Error(`HostInfo is not set. Please set it first using 'setHostInfo()'.`);
  }
  return host;
}
export {
  getHostInfo,
  getIsModalVisible,
  isModalVisible
};
//# sourceMappingURL=getters.js.map
